import {AfterContentChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
// TODO(RZ-2562): Replace legacy VO types (ContactVO) with SDK equivalents (ContactInformation)
import {ContactVO} from '../../../../generate/ContactVO';
import {ChangeVO} from '../../../../generate/ChangeVO';
import {UtilService} from '../../../../util/util.service';

@Component({
    selector: 'contact-info-view',
    templateUrl: './contact-info-view.component.html',
    styleUrls: ['./contact-info-view.component.scss'],
    standalone: false
})
export class ContactInfoViewComponent implements AfterContentChecked {

  @Input()
  contactVO: ContactVO;

  @Input()
  change: ChangeVO;

  @Input()
  lastchange: string;

  @Input()
  pendingRequestChangeID: string;

  @Input()
  hasNonTechnicalPermission: boolean;

  @Output()
  edit = new EventEmitter<boolean>();
  @Input()
  viewMode: boolean;
  constructor(private utilService: UtilService) {
  }

  ngAfterContentChecked() {
  }


  onEdit(): void {
    this.edit.emit(true);
  }

}
